export const isBengaliText = (text) => {
  const bengaliRange = /[\u0980-\u09FF]/;
  return bengaliRange.test(text);
}; 